const de = {
  dashboard: {
    title: "DASHBOARD",
    greeting: "Guten Tag",
    new_policy: "Neue Police",
    new_client: "Neuer Kunde",
    clients_actifs: "Aktive Kunden",
    dossiers_etude: "Vorgänge in Bearbeitung",
    prime_annuelle: "Jahresprämie",
    polices_actives: "aktive Policen",
    sinistres_ouverts: "offene Schäden",
    a_traiter: "Zu bearbeitende Vorgänge",
    rien_a_traiter: "Keine offenen Vorgänge — alles ist aktuell",
    portefeuille: "Portfolio",
    polices: "Policen",
    dash_st_validation: "Freigabe",
    dash_st_pieces: "Unterlagen",
    dash_st_demande: "Anfrage",
  },
  lang: { fr: 'Français', en: 'English', de: 'Deutsch', sv: 'Svenska' },

  nav: { rcpro_studies: "Prüfanträge", gf_studies: "Prüfanträge", gf_requests: "Eröffnungsanträge", gf_declarations: "Umsatzmeldungen",
    voyageur_subtitle: 'Vervollständigen Sie Ihre Schadensakte',
    creer_acces_subtitle: 'Konto erstellen, damit der Reisende seine Akte online vervollständigen kann.',
    acces_deja: 'Für diese Akte existiert bereits ein Reisendenzugang',
    role_voyageur: 'Reisender',
    creer_acces_client: "Kundenzugang erstellen",
    creer_acces_client_subtitle: "Konto erstellen, damit der Kunde seine Policen online verwalten kann.",
    acces_client_cree: "Kundenzugang erstellt — Zugangsdaten weiterleiten",
    acces_client_deja: "Für dieses Konto existiert bereits ein Kundenzugang",
    client_space: "Mein Kundenbereich",
    client_mes_polices: "Meine Policen",
    role_client: "Kunde",
    dashboard: "Dashboard",
    section_pilotage: "Steuerung",
    role_manager: 'Manager',
    role_souscripteur: 'Admin',
    role_accounts: 'Accounts',
    role_it: 'IT',
    role_courtier: 'Makler',
    role_client: 'Kunde',
    section_sinistres: 'Schäden',
    section_gestion: 'Verwaltung',
    section_portfolio: 'Portfolio',
    section_administration: 'Administration',
    utilisateurs: 'Benutzerkonten',
    intermediaires: 'Vermittler',
    sinistres: 'Schadensverwaltung',
    clients: 'Kunden',
    polices: 'Berufshaftpflicht',
    gf: 'Insolvenzversicherung',
    crm_subtitle: 'CRM',
    prestataires: 'Dienstleister & TOs',
    closed_dossiers: 'Abgeschlossene Akten',
    pending_payment: 'Wartet auf Zahlung',
    pending_balances: 'Ausstehende Salden',
    pending_validation: 'Wartet auf Validierung',
    gestion_doc: "Dokumentenverwaltung",
  },

  common: { edit: "Bearbeiten", modifier: "Bearbeiten",
    saved: 'Gespeichert',
    ok: 'OK',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    deleting: 'Wird gelöscht…',
    open: 'Öffnen',
    modify: 'Bearbeiten',
    consult: 'Ansehen',
    generate: 'Erstellen',
    close: 'Schließen',
    previous: '← Zurück',
    next: 'Weiter →',
    yes: 'Ja',
    no: 'Nein',
    loading: 'Lädt…',
    creating: 'Wird erstellt…',
    slide: 'Schritt',
    of: '/',
    all_countries: 'Alle Länder',
    all_statuses: 'Alle Status',
    actions: 'Aktionen',
    status: 'Status',
    country: 'Land',
    none: '—',
    not_found: 'Nicht gefunden.',
    no_results: 'Keine Ergebnisse gefunden.',
    error: 'Fehler',
    access_denied: 'Zugriff verweigert',
    required: '*',
    optional: '(optional)',
    irreversible: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    auto_generated: 'Automatisch erstellt',
    locked: 'Gesperrt',
    consultation_only: '🔒 Nur Ansicht',
    generate_coming_soon: 'Vorlage in Vorbereitung',
    download: '⬇ Erstellen',
    locked_after_binding: '🔒 Nach Vertragsabschluss verfügbar',
    locked_after_activation: '🔒 Nach Aktivierung',
    yes_col: 'Ja',
    no_col: 'Nein',
    suspend: 'Aussetzen',
    reactivate: 'Reaktivieren',
    unlock_btn: 'Entsperren',
    unlock_confirm: 'Dieses Dokument wieder zur Prüfung freigeben?',
    doc_gf_cert_immat: "Handelsregisterauszug",
    doc_gf_statuts: "Gesellschaftssatzung",
    doc_gf_cv_dirigeant: 'Lebenslauf des Geschäftsführers',
    doc_gf_piece_id: "Ausweisdokument des Geschäftsführers",
    doc_gf_presentation_projet: 'Projektpräsentation',
    doc_gf_previsionnel: "Detaillierte Geschäftsprognose",
    doc_gf_cgv: 'Allgemeine Geschäftsbedingungen',
    doc_gf_presentation_activites: 'Tätigkeitspräsentation',
    doc_gf_previsionnel_annuel: "Geschäftsprognose für das zu sichernde Jahr",
    doc_gf_bilan_cr: 'Letzter Jahresabschluss und detaillierte GuV',
    doc_gf_attestation_rcpro: 'Aktuelle Berufshaftpflichtbescheinigung',
    doc_gf_attestation_fonds: 'Bescheinigung über gehaltene Spitzenbeträge',
    readonly_banner: 'Nur-Lese-Ansicht — Hochladen und Anzeigen',
    broker_readonly: 'Als Makler können Sie die Kundenakten nur ansehen.',
    address_siege: 'Hauptsitzadresse',
    broker_status_locked: 'Interessent — Status wird vom Arcus-Sachbearbeiter festgelegt',
    accepted_label: 'akzeptiert',
    required_label: 'Erforderlich',
    delete_btn: '🗑 Löschen',
    doc_contrat_reservation: "Kopie des Buchungsvertrags mit dem Reisebüro",
    doc_preuve_paiement: 'Zahlungsnachweis(e)',
    doc_bon_voucher: 'Nicht eingelöster Gutschein / Voucher (falls vorhanden)',
    delete_confirm: 'Löschen',
    coming_soon: "Funktion folgt in Kürze",
  },

  status: { devis_rcpro: "Angebot (Unterlagen ausstehend)", demande_pieces: "Unterlagen & Informationen angefordert", en_cours_etude: "In Prüfung", demande_ouverture: "Antrag ausstehend", demande_refusee: "Antrag abgelehnt",
    actif: 'Aktiv',
    suspendu: 'Ausgesetzt',
    prospect: 'Interessent',
    client_actif: 'Aktiver Kunde',
    devis: 'Angebot',
    souscrit: 'Abgeschlossen',
    resilie: 'Gekündigt',
    sans_objet: 'Nicht zutreffend',
    amende: 'Geändert',
    projet_avenant: "Nachtragsentwurf",
    avenant_actif: 'Nachtrag aktiv',
    remplace: 'Ersetzt',
    en_vigueur: 'In Kraft',
    renouvellement: 'Verlängerung',
    en_souscription: 'In Abschluss',
    renouvelee: "Verlängert",
  },

  intermediaires: {
    title: 'Vermittlerverwaltung',
    create_btn: '+ Vermittler erstellen',
    search_placeholder: 'Suche nach Name, Typ, Berufsnummer…',
    count: 'Vermittler',
    count_plural: 'Vermittler',
    not_assignable: '· Keinem Kunden zuweisbar',
    col_name: 'NAME / STRUKTUR',
    col_type: 'TYP',
    col_country: 'LAND',
    col_status: 'STATUS',
    col_actions: 'AKTIONEN',
    type_courtier: 'Makler',
    type_avocat: 'Anwalt',
    type_association: 'Verband',
    type_formation: 'Schulungseinrichtung',
    contacts_count: 'Kontakt',
    contacts_count_plural: 'Kontakte',
    unlock_btn: 'Entsperren',
    unlock_confirm: 'Dieses Dokument wieder zur Prüfung freigeben?',
    doc_gf_cert_immat: "Handelsregisterauszug",
    doc_gf_statuts: "Gesellschaftssatzung",
    doc_gf_cv_dirigeant: 'Lebenslauf des Geschäftsführers',
    doc_gf_piece_id: "Ausweisdokument des Geschäftsführers",
    doc_gf_presentation_projet: 'Projektpräsentation',
    doc_gf_previsionnel: "Detaillierte Geschäftsprognose",
    doc_gf_cgv: 'Allgemeine Geschäftsbedingungen',
    doc_gf_presentation_activites: 'Tätigkeitspräsentation',
    doc_gf_previsionnel_annuel: "Geschäftsprognose für das zu sichernde Jahr",
    doc_gf_bilan_cr: 'Letzter Jahresabschluss und detaillierte GuV',
    doc_gf_attestation_rcpro: 'Aktuelle Berufshaftpflichtbescheinigung',
    doc_gf_attestation_fonds: 'Bescheinigung über gehaltene Spitzenbeträge',
    readonly_banner: 'Nur-Lese-Ansicht — Hochladen und Anzeigen',
    broker_readonly: 'Als Makler können Sie die Kundenakten nur ansehen.',
    address_siege: 'Hauptsitzadresse',
    broker_status_locked: 'Interessent — Status wird vom Arcus-Sachbearbeiter festgelegt',
    accepted_label: 'akzeptiert',
    required_label: 'Erforderlich',
    delete_btn: '🗑 Löschen',
    doc_contrat_reservation: "Kopie des Buchungsvertrags mit dem Reisebüro",
    doc_preuve_paiement: 'Zahlungsnachweis(e)',
    doc_bon_voucher: 'Nicht eingelöster Gutschein / Voucher (falls vorhanden)',
    delete_confirm: 'Sind Sie sicher, dass Sie löschen möchten',
    new_title: 'Neuer Vermittler',
    edit_title: "Vermittler bearbeiten",
    breadcrumb: 'Vermittler',
    tab_profile: "Der Vermittler",
    tab_contacts: 'Die Kontakte',
    tab_contract: 'Vertragsbedingungen',
    type_label: 'Typ *',
    courtier_fields_title: 'SPEZIFISCHE FELDER — MAKLER',
    professional_number: 'Berufsnummer',
    reference_code: 'Maklerreferenzcode',
    professional_number_placeholder: 'Bsp. CIF-FR-123456',
    reference_code_placeholder: 'Bsp. ARC-2024-001',
    structure_name: 'Name der Struktur *',
    legal_status: 'Rechtsform',
    registration_number: "Handelsregisternummer",
    registration_placeholder: 'Bsp. 12345678900012',
    addresses: 'ADRESSEN',
    main_address: '🏠 Hauptadresse',
    add_address: '+ Adresse hinzufügen',
    address_line1: 'Adresse 1',
    address_line2: 'Adresse 2',
    postal_code: 'PLZ',
    city: 'Stadt',
    address1_placeholder: 'Hausnummer und Straße',
    address2_placeholder: 'Zusatz (optional)',
    postal_placeholder: '10115',
    title_contact: 'Anrede',
    role: 'Status / Funktion',
    first_name: 'Vorname',
    last_name: 'Nachname *',
    email: 'E-Mail',
    phone: 'Telefon',
    comm_recipient: 'Empfänger der Mitteilungen',
    main_contact: 'Hauptkontakt',
    add_contact: '+ Kontakt hinzufügen',
    remunerated: 'Vergüteter Vermittler?',
    remunerated_desc: "Wenn ja, wird ein Provisionssatz auf die vermittelten Verträge angewendet.",
    commission_rate: 'Provisionssatz *',
    commission_auto: 'Die Provision wird automatisch auf die zugeordneten Verträge angewendet.',
    not_remunerated_info: "Für diesen Vermittler wird keine Provision generiert.",
    suspension_date: 'Aussetzungsdatum',
  },

  clients: {
    title: 'Kundenverwaltung',
    create_btn: '+ Kunde erstellen',
    search_placeholder: 'Suche nach Name, Tätigkeit, Land…',
    count: 'Kunde',
    count_plural: 'Kunden',
    col_name: 'NAME / UNTERNEHMEN',
    col_activity: 'HAUPTTÄTIGKEIT',
    col_relation: 'BEZIEHUNG',
    col_country: 'LAND',
    col_status: 'STATUS',
    col_actions: 'AKTIONEN',
    via: 'über',
    new_title: 'Neuer Kunde',
    edit_title: 'Kunde bearbeiten',
    breadcrumb: 'Kunden',
    tab_relation: 'Die Beziehung',
    tab_company: "Das Unternehmen",
    tab_contacts: 'Die Kontakte',
    tab_activities: 'Die Tätigkeiten',
    client_status: 'Kundenstatus',
    client_status_desc: 'Bestimmt den Betreuungsgrad und die verfügbaren Aktionen.',
    market: 'Markt *',
    market_placeholder: '— Land auswählen —',
    relation_type: 'Beziehungstyp *',
    direct: 'Direkt',
    brokered: 'Vermittelt',
    broker_label: 'Makler *',
    broker_placeholder: '— Makler auswählen —',
    broker_auto_commission: 'Der Provisionssatz des Maklers wird automatisch auf die Policen angewendet.',
    third_party: 'DRITTPARTEI',
    third_party_desc: "Auswählen, wenn ein Dritter an der Beziehung beteiligt ist (Anwalt, Verband, sonstige). Mehrere Auswahlmöglichkeiten.",
    company_name: "Firmenname *",
    company_placeholder: 'Bsp. Reisen Welt GmbH',
    legal_status: 'Rechtsform',
    registration: "Handelsregisternummer (HRB)",
    registration_placeholder: 'Bsp. HRB 892345',
    unlock_btn: 'Entsperren',
    unlock_confirm: 'Dieses Dokument wieder zur Prüfung freigeben?',
    doc_gf_cert_immat: "Handelsregisterauszug",
    doc_gf_statuts: "Gesellschaftssatzung",
    doc_gf_cv_dirigeant: 'Lebenslauf des Geschäftsführers',
    doc_gf_piece_id: "Ausweisdokument des Geschäftsführers",
    doc_gf_presentation_projet: 'Projektpräsentation',
    doc_gf_previsionnel: "Detaillierte Geschäftsprognose",
    doc_gf_cgv: 'Allgemeine Geschäftsbedingungen',
    doc_gf_presentation_activites: 'Tätigkeitspräsentation',
    doc_gf_previsionnel_annuel: "Geschäftsprognose für das zu sichernde Jahr",
    doc_gf_bilan_cr: 'Letzter Jahresabschluss und detaillierte GuV',
    doc_gf_attestation_rcpro: 'Aktuelle Berufshaftpflichtbescheinigung',
    doc_gf_attestation_fonds: 'Bescheinigung über gehaltene Spitzenbeträge',
    readonly_banner: 'Nur-Lese-Ansicht — Hochladen und Anzeigen',
    broker_readonly: 'Als Makler können Sie die Kundenakten nur ansehen.',
    address_siege: 'Hauptsitzadresse',
    broker_status_locked: 'Interessent — Status wird vom Arcus-Sachbearbeiter festgelegt',
    accepted_label: 'akzeptiert',
    required_label: 'Erforderlich',
    delete_btn: '🗑 Löschen',
    doc_contrat_reservation: "Kopie des Buchungsvertrags mit dem Reisebüro",
    doc_preuve_paiement: 'Zahlungsnachweis(e)',
    doc_bon_voucher: 'Nicht eingelöster Gutschein / Voucher (falls vorhanden)',
    delete_confirm: "Dieser Kunde hat aktive Policen. Löschen Sie diese zuerst.",
    contacts_section: 'Die Kontakte',
    main_contact: 'Hauptkontakt',
    contact_number: 'Kontakt',
    add_contact: '+ Kontakt hinzufügen',
    title_contact: 'Anrede',
    role: 'Status / Funktion',
    first_name: 'Vorname',
    last_name: 'Nachname *',
    email: 'E-Mail',
    phone: 'Telefon',
    comm_recipient: 'Empfänger der Mitteilungen',
    activities_section: 'Die Tätigkeiten',
    principal_activity: 'Haupttätigkeit',
    principal_activity_desc: "Dominante Tätigkeit des Reisebüros (Einzelauswahl)",
    secondary_activities: 'Nebentätigkeiten',
    secondary_activities_desc: 'Andere ausgeübte Tätigkeiten (Mehrfachauswahl)',
    no_activity_selected: "Wählen Sie zuerst eine Haupttätigkeit aus",
  },

  client_detail: {
    modify_fiche: 'Akte bearbeiten',
    legal_status: 'Rechtsform',
    registration: 'Handelsregister-Nr.',
    market: 'Markt',
    distribution: 'Vertrieb',
    direct_distribution: 'Direkt (+15 % Arcus)',
    brokered_distribution: 'Vermittelt',
    address_label: '📍',
    policies_title: "Versicherungspolicen",
    contract_count: 'Vertrag',
    contract_count_plural: 'Verträge',
    create_policy: '+ Neue Berufshaftpflicht-Police',
    no_policies: 'Keine Police für diesen Kunden. Klicken Sie auf "Neue Police" um ein Angebot zu erstellen.',
    col_piece: 'BELEGNUMMER',
    col_status: 'STATUS',
    col_premium: 'BRUTTOPRÄMIE',
    col_effect: "VERTRAGSBEGINN",
    col_expiry: 'FÄLLIGKEIT',
    col_actions: 'AKTIONEN',
    renew: '🔄 Verlängern',
    terminate: 'Kündigen',
    amendment_prefix: 'Nachtrag Nr.',
    new_amendment: '✎ Neuer Nachtrag',
    expiry_warning: '⚠',
    renewal_line: "Verlängert am",
    collapse: "Einklappen",
    expand: "Ausklappen",
    previous_period: "Vorherige Periode",
  },

  polices: {
    title: 'Berufshaftpflicht',
    breadcrumb: 'Policen',
    portfolio_title: 'Berufshaftpflicht-Portfolio',
    create_from_client: 'Policen werden über die Kundenakte erstellt',
    col_client: 'KUNDE / POLICEN-NR.',
    col_country: 'LAND',
    col_premium: 'BRUTTOPRÄMIE',
    col_expiry: 'FÄLLIGKEIT',
    col_status: 'STATUS',
    tab_policy: 'Die Police',
    tab_tarification_gf: 'Tarifierung',
    tarif_add_period: '+ Periode hinzufügen',
    tarif_period: 'Periode',
    tarif_date_debut: 'Startdatum',
    tarif_date_fin: 'Enddatum',
    tarif_exposition: 'Exposition (€)',
    tarif_taux: 'Satz (%)',
    tarif_prime_ht: 'Nettoprämie',
    tarif_taxe: 'Steuer (9%)',
    tarif_prime_ttc: 'Bruttoprämie',
    tarif_total: 'GESAMTBRUTTOPRÄMIE',
    tarif_hint: 'Nettoprämie = Exposition × Satz · Steuer = 9% · Bruttoprämie = Nettoprämie + Steuer',
    tab_underwriting: 'Informationssammlung',
    tab_tarification: 'Tarifierungsbereich',
    tab_documents: 'Dokumente',
    client_readonly: 'Kunde — nicht änderbar',
    risk_insured_title: 'Ist das Risiko bereits versichert?',
    risk_insured_yes: 'Übernahme von Wettbewerbern — Schadenshistorie erforderlich',
    risk_insured_no: 'Erstversicherung',
    current_insurer: 'Aktueller Versicherer *',
    policy_status: 'Policenstatus',
    quote_number: 'Angebotsnummer',
    policy_number: 'Policennummer',
    policy_number_required: 'Erforderlich für Zugriff auf Tarifierung',
    effect_date: "Vertragsbeginn *",
    expiry_date: "Fälligkeitsdatum",
    expiry_auto: '(auto +1 Jahr)',
    renewal_note: '🔄 Verlängerung durch stillschweigende jährliche Verlängerung.',
    locked_banner: 'Vertrag abgeschlossen (nur Ansicht)',
    renewal_banner: '🔄 Verlängerung — Periode',
    to: 'bis',
    create_amendment: '✎ Nachtrag erstellen',
    renew_btn: '🔄 Verlängern',
    terminate_btn: 'Kündigen',
    move_to_bound: 'Auf Abgeschlossen setzen',
    confirm_binding_title: '⚠ Abschluss bestätigen',
    confirm_binding_desc: 'Sie sind dabei, diesen Vertrag abzuschließen.',
    confirm_binding_warning: 'Alle Felder werden gesperrt.',
    renewal_title: '🔄 Verlängerung erstellen',
    renewal_question: 'Möchten Sie diesen Vertrag zu denselben Konditionen verlängern wie',
    renewal_last_active: 'der letzte aktive Stand',
    renewal_same: '✓ Ja — gleiche Konditionen',
    renewal_same_desc: 'Die Verlängerung übernimmt alle aktuellen Werte. Neue Daten werden automatisch gesetzt.',
    renewal_new: '✎ Nein — neue Konditionen',
    renewal_new_desc: "Das Formular öffnet sich vorausgefüllt. Sie geben den neuen Umsatz ein.",
    declared_ca: 'Deklarierter Umsatz (€) *',
    payment_freq: 'Zahlungsweise',
    loading_factors: "Fragen zu den Tätigkeiten",
    discount_factors: 'Nachlassfaktoren',
    covered_activities: "Ausgeübte Tätigkeiten",
    special_conditions: 'Besondere Bedingungen',
    special_conditions_hint: 'Wenn leer → „Keine" im Dokument.',
    special_conditions_placeholder: 'Besondere Klausel, die im Vertrag erscheinen soll…',
    loss_history: 'Schadenshistorie',
    loss_takeover: 'Übernahme · Versicherer',
    loss_closed: 'Abgeschlossene Schäden (> 1 500 €)',
    loss_open: 'Offene Schäden (> 1 500 €)',
    loss_total_paid: 'Insgesamt gezahlt (€)',
    loss_count: 'Anzahl',
    loss_provision: 'Rückgestellt (€)',
    loss_partial: 'Teilweise gezahlt (€)',
    loss_years: 'Jahre laut Auszug',
    net_premium: 'Nettoprämie',
    commission: 'Provision',
    tax: 'Steuer',
    gross_premium: 'Bruttoprämie',
    above_ceiling: "⚠ Umsatz über 10 Mio. € — direkt beim Versicherer einreichen.",
    enter_ca: 'Umsatz eingeben, um die Prämienberechnung anzuzeigen.',
    floor_applied: '· Mindestbetrag 600 € angewandt',
    global_coeff: 'Globaler Koeff.',
    freq_annual: 'Jährlich (+0 %)',
    freq_semi: 'Halbjährlich (+2 %)',
    freq_quarter: 'Vierteljährlich (+4 %)',
    freq_month: 'Monatlich (+6 %)',
    internal_notes: 'Interne Notizen',
    notes_placeholder: "Zeichnungsnotizen, besondere Bedingungen…",
    maj_q1: 'Mehr als 50 % des Umsatzes mit Sportreisen, Hochzeiten, Junggesellenabschieden?',
    maj_q2: '50 % oder mehr der Passagiere / Umsatz in Länder außerhalb der EU, Skandinavien, Schweiz, AUS, NZ?',
    maj_q3: 'Deckungserweiterung USA / Kanada?',
    maj_q4: 'Gruppenreisen mit mehr als 10 Personen?',
    maj_q5: '50 % oder mehr der Aufenthalte beinhalten einen nicht standardmäßigen Transfer (4×4, Boot, Flugzeug)?',
    maj_q6: '50 % oder mehr der Aufenthalte beinhalten Risikoaktivitäten (Ski, Tauchen, Fallschirmspringen…)?',
    min_q1: 'Schadenfreie Historie über die letzten 48 Monate?',
    min_q2: "Geschäftsführer mit mehr als 10 Jahren Erfahrung in Reisebüro oder Reiseveranstaltung?",
    act1: 'Ticketverkauf',
    act2: "Organisation von Aufenthalten oder Reisen in Frankreich oder im Ausland",
    act3: 'Verkauf von Aufenthalten oder Reisen eines Reiseveranstalters',
    act4: "Incoming-Tourismus",
    act5: "Provisionsverkauf (Hotel, Mietwagen, Assistance, Theater…)",
    doc_language: '🌐 Sprache: Französisch · Französisches Recht gilt',
    doc_devis_warning: '⚠ Status Angebot — Police und Bescheinigung nach Abschluss verfügbar.',
    doc_locked_docs: 'Vertragsunterlagen',
    doc_project: "Versicherungsentwurf",
    doc_project_desc: 'Präsentationsdokument zum Angebot',
    doc_policy: 'Besondere Bedingungen',
    doc_cg: 'Allgemeine Bedingungen',
    doc_attestation: "Versicherungsbescheinigung",
    doc_attestation_desc: 'Deckungsnachweis Berufshaftpflicht',
    direct_plus15: 'Direkt · +15 % Arcus',
    brokered_comm: 'Vermittelt · % Makler',
    broker_view_banner: 'Maklersicht — nur Ansicht und Dokumenten-Upload',
    broker_docs_locked: '🔒 Nach Vertragsabschluss verfügbar',
    confirm_binding_docs_missing: 'Erforderliche Dokumente nicht freigegeben — Abschluss nicht möglich',
    doc_waiting_approval: 'Hochgeladen, aber Freigabe ausstehend',
    doc_not_uploaded: 'Nicht hochgeladen',
    docs_in_french: 'Dokumente auf Französisch',
    warn_date_effet_locked: "Änderung möglich aber sensibel — prüfen Sie die Auswirkung auf Nachträge und eventuelle Verlängerungen",
    // ── Workflow étude/souscription RC Pro ──
    etude_title: "Fallprüfung",
    etude_locked_note: "Abschnitt gesperrt — die Police ist abgeschlossen.",
    numero_projet: "Projektnummer",
    date_effet_prev: "Voraussichtliches Wirksamkeitsdatum",
    rcpro_step_devis: "Angebot (Unterlagen ausstehend)",
    rcpro_step_devis_hint: "Der Makler/Kunde vervollständigt die Akte und übermittelt sie an Arcus.",
    rcpro_step_etude_hint: "Erreicht, wenn der Makler/Kunde den Zeichnungsantrag übermittelt.",
    repasser_devis_btn: "Zurück zu Angebot",
    repasser_devis_confirm_title: "Akte zurück zu Angebot setzen?",
    repasser_devis_confirm_desc: "Das Formular wird für den Makler/Kunden wieder bearbeitbar; bereits eingegebene Daten bleiben erhalten. Die Akte kehrt zum Status „Angebot (Unterlagen ausstehend)“ zurück.",
    repasser_devis_confirm_btn: "Zurücksetzen",
    police_locked_note: "Abschnitt wird beim Abschluss der Police aktiviert.",
    souscrire_btn: "Police abschließen",
    souscrire_need_date: "Wirksamkeitsdatum angeben.",
    souscrire_need_npolice: "Policennummer angeben.",
    souscrire_confirm_title: "Police abschließen",
    souscrire_confirm_desc: "Bestätigen Sie die Angaben unten, um die Police zu erstellen. Der Abschnitt „Police“ wird aktiviert und die Prüfung gesperrt.",
    souscrire_date_label: "Wirksamkeitsdatum der Police",
    souscrire_npolice_label: "Policennummer",
    souscrire_confirm_btn: "Abschließen",
    // ── RC Pro : onglet Souscription + mention spéciale ──
    ajustement_title: "Tarifanpassung",
    ajustement_hint: "Freiwillige Prämienerhöhung (kann sie nicht senken).",
    ajustement_coeff: "Koeffizient (z. B. 1,25 = +25 %)",
    ajustement_min_note: "Minimum 1,00 (keine Senkung)",
    discount_hint: "Ankreuzen, um den Abschlag auf das laufende Angebot anzuwenden.",
    dossier_decline_banner: "Akte abgelehnt — das Risiko wurde von Arcus abgelehnt.",
    dossier_decline_status: "Akte abgelehnt",
    exclusion_title: "\"Festlich\"-Ausschluss",
    exclusion_remove_label: "Ausschluss entfernen",
    exclusion_text: "Organisation, Verkauf oder Weiterverkauf von Reisen/Aufenthalten mit festlichem Charakter wie Junggesellen-/Junggesellinnenabschiede, Springbreak, Studierendenreisen…",
    exclusion_present_note: "Der Ausschluss erscheint im Versicherungsentwurf.",
    exclusion_removed_note: "Der Ausschluss ist entfernt und erscheint nicht im Versicherungsentwurf.",
    mention_approve: "Genehmigen",
    mention_approved: "Vermerk von Arcus genehmigt.",
    mention_client_request: "Anfrage des Kunden / Maklers",
    mention_none: "Keine Anfrage für Sondervermerk.",
    mention_pending: "Anfrage an Arcus Solutions gesendet — Bearbeitung ausstehend.",
    mention_reformulate: "Umformulieren",
    mention_reformulate_confirm: "Umformulierung bestätigen",
    mention_reformulate_empty: "Umformulierung eingeben.",
    mention_reformulate_label: "Umformulierung des Vermerks",
    mention_reformulated: "Vermerk von Arcus umformuliert.",
    mention_refuse: "Risiko ablehnen",
    mention_refused: "Risiko abgelehnt — Akte abgelehnt.",
    mention_submit_btn: "Anfrage an Arcus Solutions senden",
    mention_submit_confirm_title: "Anfrage an Arcus senden?",
    mention_submit_confirm_desc: "Ihre Anfrage wird zur Prüfung an Arcus Solutions gesendet. Die Akte wird gesperrt und bis zur Entscheidung von Arcus kann kein Dokument heruntergeladen werden.",
    mention_submit_confirm_btn: "Anfrage senden",
    tab_souscription: "Zeichnung",
  },

  resiliation: {
    title: 'Vertrag kündigen',
    title_amendment: "Nachtrag kündigen",
    motif_label: 'Kündigungsgrund *',
    motif_echeance: "Kündigung zum Ablauf",
    motif_echeance_desc: "Der Vertrag wird zum Fälligkeitsdatum gekündigt.",
    motif_disparition: 'Wegfall des Risikos',
    motif_disparition_desc: 'Kündigungsdatum eintragen. Prorata wird automatisch berechnet.',
    motif_aggravation: 'Risikoerhöhung',
    motif_aggravation_desc: 'Benachrichtigungsdatum erforderlich. Kündigung 10 Tage später. Prorata wird berechnet.',
    motif_nonpaiement: 'Nichtzahlung',
    motif_nonpaiement_desc: 'Kündigungsdatum eintragen. Keine Prämienrückerstattung.',
    notif_date: 'Benachrichtigungsdatum *',
    resil_date: 'Kündigungsdatum *',
    j_plus_10: '(T+10)',
    prorata_title: 'Pro rata temporis',
    prorata_total: 'Gesamtdauer',
    prorata_remaining: 'Verbleibende Tage',
    prorata_refund: 'Zu erstatten',
    prorata_days: 'Tage',
    note_label: 'Interne Notiz',
    note_placeholder: 'Kontext der Kündigung…',
    confirm_btn: '✓ Kündigung bestätigen',
  },

  amendements: {
    tab_amendment: "Der Nachtrag",
    tab_tarification_gf: 'Tarifierung',
    tarif_add_period: '+ Periode hinzufügen',
    tarif_period: 'Periode',
    tarif_date_debut: 'Startdatum',
    tarif_date_fin: 'Enddatum',
    tarif_exposition: 'Exposition (€)',
    tarif_taux: 'Satz (%)',
    tarif_prime_ht: 'Nettoprämie',
    tarif_taxe: 'Steuer (9%)',
    tarif_prime_ttc: 'Bruttoprämie',
    tarif_total: 'GESAMTBRUTTOPRÄMIE',
    tarif_hint: 'Nettoprämie = Exposition × Satz · Steuer = 9% · Bruttoprämie = Nettoprämie + Steuer',
    tab_underwriting: 'Informationssammlung',
    tab_documents: 'Dokumente',
    replaced_contract: 'Ersetzter Vertrag',
    current_policy: 'Policen-Nr.',
    current_premium: 'Aktuelle Bruttoprämie',
    client: 'Kunde',
    effect_date: "Datum des Inkrafttretens des Nachtrags *",
    effect_date_hint: 'Freie Eingabe — kann rückwirkend oder zukünftig sein.',
    notes_label: "Interne Notizen (Grund des Nachtrags)",
    notes_placeholder: "Bsp.: Tätigkeitsänderung, Umsatzsteigerung…",
    comparison_title: '⇄ Vergleich mit dem laufenden Vertrag',
    current_contract: 'Aktueller Vertrag',
    amendment_label: 'Nachtrag',
    difference: 'Unterschied',
    increase_msg: '↑ Erhöhung · Nachforderung',
    decrease_msg: '↓ Minderung · Ausgleich auf 0 € — keine Rückerstattung',
    stable_msg: '= Identische Prämie — Nachtrag ohne finanzielle Auswirkung',
    activate_btn: 'Aktivieren',
    activate_disabled: "Datum des Inkrafttretens für Aktivierung erforderlich",
    confirm_activate_title: "⚠ Aktivierung bestätigen",
    confirm_activate_desc: 'wird den aktuellen Vertrag ersetzen.',
    confirm_activate_irreversible: 'Der ursprüngliche Vertrag wird archiviert.',
    locked_banner: '🔒 Nachtrag aktiv — Felder gesperrt (nur Ansicht).',
    doc_project: "Nachtragsentwurf",
    doc_project_desc: 'Präsentationsdokument',
    doc_project_warning: "⚠ Status Nachtragsentwurf — Vertragsunterlagen werden nach Aktivierung freigegeben.",
    doc_section_project: 'Projektakte',
    doc_section_contracts: 'Vertragsunterlagen',
    doc_appel_section: 'Nachforderung / Ausgleich',
    doc_appel_title: 'Zusätzliche Nachforderung',
    doc_appel_amount: 'Betrag',
    doc_regularisation: 'Ausgleichsschreiben',
    doc_regularisation_desc: "Ausgleich auf 0 € — keine Nachforderung",
    delete_title: "Nachtrag löschen",
    unlock_btn: 'Entsperren',
    unlock_confirm: 'Dieses Dokument wieder zur Prüfung freigeben?',
    doc_gf_cert_immat: "Handelsregisterauszug",
    doc_gf_statuts: "Gesellschaftssatzung",
    doc_gf_cv_dirigeant: 'Lebenslauf des Geschäftsführers',
    doc_gf_piece_id: "Ausweisdokument des Geschäftsführers",
    doc_gf_presentation_projet: 'Projektpräsentation',
    doc_gf_previsionnel: "Detaillierte Geschäftsprognose",
    doc_gf_cgv: 'Allgemeine Geschäftsbedingungen',
    doc_gf_presentation_activites: 'Tätigkeitspräsentation',
    doc_gf_previsionnel_annuel: "Geschäftsprognose für das zu sichernde Jahr",
    doc_gf_bilan_cr: 'Letzter Jahresabschluss und detaillierte GuV',
    doc_gf_attestation_rcpro: 'Aktuelle Berufshaftpflichtbescheinigung',
    doc_gf_attestation_fonds: 'Bescheinigung über gehaltene Spitzenbeträge',
    readonly_banner: 'Nur-Lese-Ansicht — Hochladen und Anzeigen',
    broker_readonly: 'Als Makler können Sie die Kundenakten nur ansehen.',
    address_siege: 'Hauptsitzadresse',
    broker_status_locked: 'Interessent — Status wird vom Arcus-Sachbearbeiter festgelegt',
    accepted_label: 'akzeptiert',
    required_label: 'Erforderlich',
    delete_btn: '🗑 Löschen',
    doc_contrat_reservation: "Kopie des Buchungsvertrags mit dem Reisebüro",
    doc_preuve_paiement: 'Zahlungsnachweis(e)',
    doc_bon_voucher: 'Nicht eingelöster Gutschein / Voucher (falls vorhanden)',
    delete_confirm: "Sind Sie sicher, dass Sie diesen Nachtrag löschen möchten",
    resiliation_info_title: 'Gekündigter Nachtrag',
    resiliation_motif: 'Grund',
    resiliation_date: 'Datum',
    resiliation_prorata: 'Prorata',
    new_amendment: '✎ Neuer Nachtrag',
  },

  documents: {
    cp: 'BB',
    attestation: 'Bescheinigung',
    cg: 'AGB',
    policy: 'Besondere Bedingungen',
    general_conditions: 'Allgemeine Bedingungen',
    certificate: "Versicherungsbescheinigung",
    quote: "Versicherungsentwurf",
  },

  auth: {
    forgot_password: "Passwort vergessen?",
    forgot_title: "Passwort vergessen",
    forgot_desc: "Geben Sie Ihre E-Mail ein, wir senden Ihnen einen Link, um ein neues Passwort festzulegen.",
    forgot_btn: "Link senden",
    forgot_sent: "Falls ein Konto mit dieser Adresse existiert, wurde gerade ein Zurücksetzungslink gesendet.",
    back_to_login: "Zurück zur Anmeldung",
    reset_title: "Neues Passwort",
    reset_desc: "Wählen Sie ein sicheres Passwort (mindestens 8 Zeichen).",
    reset_btn: "Passwort festlegen",
    reset_success: "Passwort festgelegt. Sie können sich jetzt anmelden.",
    redirecting: "Weiterleitung zur Anmeldeseite…",
    password_mismatch: "Die Passwörter stimmen nicht überein.",
    password_too_short: "Mindestens 8 Zeichen.",
    email_required: "E-Mail erforderlich.",
    welcome: 'Willkommen',
    sign_in_desc: 'Melden Sie sich bei Ihrem ARCUSCONNECT-Bereich an',
    email: 'E-Mail-Adresse',
    email_placeholder: 'ihre@email.de',
    password: 'Passwort',
    password_placeholder: '••••••••',
    sign_in: 'Anmelden',
    signing_in: 'Anmeldung läuft…',
    logout: 'Abmelden',
    fill_all: 'Bitte füllen Sie alle Felder aus',
    access_levels: "Zugriffsebenen",
    change_password: 'Passwort ändern',
    current_password: 'Aktuelles Passwort',
    new_password: 'Neues Passwort',
    confirm_password: 'Passwort bestätigen',
    password_changed: 'Passwort erfolgreich geändert',
  },
  sinistres: {
    title: 'Schadensverwaltung',
    subtitle: "Entschädigungsverfahren nach Insolvenz von Reisebüros",
    open_procedure: 'Verfahren eröffnen',
    filter_all: 'Alle',
    col_numero: 'Verfahrens-Nr.', col_agence: 'Reisebüro', col_statut: 'Status',
    col_date_ouv: "Eröffnungsdatum", col_date_fin: 'Ende der Entschädigung', col_actions: 'Aktionen',
    no_procedures: 'Keine Schadensverfahren erfasst.',
    open_btn: 'Öffnen', loading: 'Lädt…',
    modal_title: 'Verfahren eröffnen',
    modal_subtitle: "Wählen Sie das insolvente Reisebüro und legen Sie die Verfahrensdaten fest.",
    select_agence: '— Reisebüro auswählen —',
    date_ouverture: "Eröffnungsdatum *", date_fin: 'Enddatum der Entschädigung',
    notes: 'Interne Notizen (optional)', notes_placeholder: 'Kontext, nützliche Informationen…',
    valider: 'Bestätigen →', creation: 'Wird erstellt…',
    confirm_title: 'Bestätigung erforderlich', confirm_subtitle: 'Unwiderrufliche Aktion — nur Manager',
    confirm_about: "Sie sind dabei, das Schadensverfahren offiziell zu eröffnen für:",
    confirm_warning: "⚠ Diese Aktion wird das Reisebüro endgültig sperren und kann nicht rückgängig gemacht werden.",
    confirm_no_manager: "Nur ein Manager-Konto kann diese Eröffnung bestätigen.",
    annuler_procedure: '✕ Verfahren abbrechen',
    confirmer_ouverture: "✓ Eröffnung bestätigen", confirmation_loading: 'Wird bestätigt…',
    agence_locked: 'Reisebüro gesperrt', procedure_label: 'Schadensverfahren',
    cloturer: 'Verfahren abschließen', infos_procedure: 'Verfahrensinformationen',
    modifier: '✎ Bearbeiten', tracabilite: 'Verlauf',
    cree: 'Verfahren erstellt', confirmee: 'Verfahren bestätigt und eröffnet',
    cloturee_label: 'Verfahren abgeschlossen', par: 'von',
    cloturer_confirm_title: 'Verfahren abschließen?',
    cloturer_confirm_body: 'Das Verfahren wird als abgeschlossen markiert. Diese Aktion kann nicht rückgängig gemacht werden.',
    cloturer_btn: 'Abschließen', pending_alert: 'Wartet auf Manager-Bestätigung',
    pending_desc: "Dieses Verfahren wurde erstellt, ist aber noch nicht offiziell eröffnet.",
    statut_ouverture_pendante: 'Wartet auf Bestätigung',
    statut_ouverte: 'Verfahren eröffnet', statut_cloturee: 'Abgeschlossen',
    dossiers_title: "Entschädigungsakten",
    ajouter_dossier: '+ Akte hinzufügen',
    no_dossiers: 'Keine Akte erfasst. Klicken Sie auf "+ Akte hinzufügen" um zu beginnen.',
    pending_dossiers: "Das Verfahren muss von einem Manager bestätigt werden, bevor Akten hinzugefügt werden können.",
    col_souhait: 'Wunsch',
    col_montant_total: 'Reisebetrag',
    col_acompte: 'Anzahlung',
    col_solde: 'Restbetrag',
    col_numero_dossier: 'Akten-Nr.', col_voyageur: 'Begünstigter', col_type: 'Typ',
    nouveau_dossier: 'Neue Akte',
    nouveau_dossier_subtitle: 'Erfassen Sie einen neuen Begünstigten der Insolvenzversicherung.',
    type_beneficiaire: 'Begünstigtentyp',
    particulier: '👤 Privatperson', professionnel: '🏢 Geschäftlich',
    nom_particulier: 'Nachname / Vorname *', nom_professionnel: 'Firmenname *',
    creer_dossier: 'Akte erstellen →', creation_dossier: 'Wird erstellt…',
    statut_dossier: 'Aktenstatus', reserved_manager: 'Nur Manager',
    validation_required: 'Manager-Freigabe erforderlich',
    validation_desc: 'Diese Akte ist bereit zur finalen Freigabe vor Zahlung.',
    decliner: '✕ Ablehnen', valider_paiement: '✓ Zahlung freigeben',
    pieces_title: 'Belege',
    pieces_desc: 'Upload und Prüfung der Begünstigtendokumente',
    finances_title: 'Finanzdaten',
    finances_desc: 'Reisebetrag, geleistete Anzahlungen, geschuldete Entschädigung',
    banque_title: 'Bankinformationen',
    banque_desc: 'IBAN, Kontoinhaber, Bankinstitut',
    a_developper: 'In Entwicklung',
    voyageur_info: 'Begünstigteninformationen',
    benef_intro: 'Bitte beantworten Sie die folgenden Fragen.',
    submit_blocked_hint: 'Füllen Sie die Pflichtangaben aus und reichen Sie alle Belege ein, um den Vorgang absenden zu können.',
    submit_missing_title: 'Um Ihren Vorgang abzusenden, fehlt noch:',
    submit_missing_fields: 'Fehlende Pflichtangaben:',
    submit_missing_pieces: 'Einzureichende Belege:',
    piece_label_generic: 'Beleg',
    passer_en_cours: 'In Bearbeitung setzen',
    passer_en_cours_title: 'Den Fall in Bearbeitung setzen?',
    passer_en_cours_desc: 'Der Fall wechselt in den Status „In Bearbeitung“, sodass Sie ihn weiterbearbeiten können, ohne auf die Übermittlung durch den Reisenden zu warten. Speichern Sie Ihre Änderungen vorher.',
    benef_date_depart: 'Abreisedatum der Reise',
    benef_carte_warning: 'Bitte stellen Sie einen Erstattungsantrag oder eine Reklamation gemäß Artikel 75. Wenn Ihre ausstellende Bank oder Ihr Kreditkartenanbieter Ihren Antrag abgelehnt hat, legen Sie bitte einen Nachweis oder eine Empfangsbestätigung dieser Ablehnung als Teil Ihrer Schadenakte bei.',
    benef_voyageurs_label: 'Betroffene Reisende',
    benef_add_voyageur: 'Reisenden hinzufügen',
    benef_voyageurs_groupe: 'Bei einer Gruppe von mehr als 10 Personen legen Sie bitte die Liste der Reisenden zusammen mit den Belegen im nächsten Abschnitt bei.',
    voyageur_titre: 'Anrede',
    voyageur_nom: 'Nachname',
    voyageur_prenom: 'Vorname',
    voyageur_email: 'E-Mail-Adresse',
    voyageur_telephone: 'Telefon',
    voyageur_titre_m: 'Herr',
    voyageur_titre_mme: 'Frau',
    voyageur_titre_mmme: 'Herr / Frau',
    voyageur_titre_ste: 'Unternehmen',
    voyageur_titre_asso: 'Verein',
    voyage_info: 'Reiseinformationen',
    voyage_intro: 'Bitte überprüfen Sie die vom Antragsteller gemachten Angaben und füllen Sie die übrigen Felder anhand der Reisedokumente aus. Korrigieren Sie bei Bedarf den Abschnitt Reiseinformationen.',
    voyage_montant_total: 'Gesamtbetrag der Reise (€)',
    voyage_acompte: 'Geleistete Anzahlung (€)',
    voyage_solde: 'Restbetrag (€)',
    voyage_solde_auto: 'Automatisch berechnet: Gesamtbetrag − Anzahlung',
    voyage_appel_fonds: 'Mittelabruf erstellen',
    voyage_appel_fonds_title: 'Mittelabruf',
    voyage_appel_fonds_soon: "Die Vorlage für den Mittelabruf wird vorbereitet.",
    voyage_appel_fonds_preview: 'Vorschau — zur Information',
    voyage_appel_fonds_email: 'Per E-Mail senden',
    voyage_appel_fonds_copy: 'Kopieren',
    voyage_appel_fonds_copied: 'Kopiert!',
    souhait_label: 'Wunsch des Reisenden',
    souhait_remboursement: 'Erstattung',
    souhait_maintien: 'Reise beibehalten',
    souhait_rapatriement: 'Rückführung',
    paiement_title: 'Zahlungsverwaltung',
    paiement_type: 'Empfängertyp',
    paiement_nom: 'Nachname',
    paiement_prenom: 'Vorname',
    paiement_adresse: 'Adresse',
    paiement_cp: 'PLZ',
    paiement_ville: 'Stadt',
    paiement_iban: 'IBAN',
    paiement_swift: 'SWIFT / BIC-Code',
    paiement_reference: 'Zahlungsreferenz',
    paiement_ref_auto: 'Automatisch generiert',
    paiement_montant: 'Zu zahlender Betrag (€)',
    paiement_ajouter: '+ Zahlung hinzufügen',
    paiement_numero: 'Zahlung Nr.',
    paiement_aucun: 'Keine Zahlung erfasst.',
    paiement_particulier: 'Privatperson',
    paiement_professionnel: 'Geschäftlich',
    supprimer_dossier: 'Akte löschen',
    supprimer_dossier_confirm: 'Möchten Sie diese Akte wirklich löschen? Diese Aktion ist unwiderruflich.',
    dossiers_count: '{n} Akte erfasst',
    dossiers_count_pl: '{n} Akten erfasst',
    type_particulier: '👤 Privatperson',
    type_professionnel: '🏢 Geschäftlich',
    dos_statut_en_attente_informations: 'Warten auf Informationen',
    dos_statut_en_cours_traitement: 'In Bearbeitung',
    dos_statut_attente_validation: 'Wartet auf Freigabe',
    dos_statut_attente_paiement_solde: 'Wartet auf Restzahlung',
    dos_statut_solde_paye: 'Saldo bezahlt',
    dos_statut_attente_paiement_compta: 'Warten auf Zahlung durch Buchhaltung',
    dos_statut_paiement_realise: 'Zahlung abgeschlossen',
    dos_statut_decline: 'Abgelehnt',
statut_auto_info: 'Der Status ändert sich automatisch je nach den durchgeführten Aktionen.',
    date_limite_paiement: 'Zahlungsfrist',
    appel_fonds_pdf: 'Mittelabruf-PDF erstellen',
    appel_fonds_email_pdf: 'Per E-Mail senden',
    appel_fonds_dl: 'Wird heruntergeladen…',
    benef_montant_facture: 'Welcher Gesamtbetrag wurde Ihnen in Rechnung gestellt? (€)',
    benef_type_reglement: 'Haben Sie eine Anzahlung oder den Gesamtbetrag bezahlt?',
    benef_type_acompte: 'Anzahlung',
    benef_type_totalite: 'Gesamtbetrag',
    benef_montant_acompte: 'In welcher Höhe? (€)',
    benef_modes_paiement: 'Wie haben Sie bezahlt?',
    benef_mode_carte: 'Kreditkarte',
    benef_mode_virement: 'Banküberweisung',
    benef_mode_cheque: 'Scheck',
    benef_mode_especes: 'Bargeld',
    benef_mode_cadeau: 'Geschenkgutschein / Guthaben / Hochzeitsliste',
    benef_nb_voyageurs: 'Wie viele Reisende sind betroffen?',
    benef_souhait_client: 'Was wünschen Sie?',
    benef_souhait_remboursement: 'Erstattung erhalten',
    benef_souhait_maintien: 'Meine Reise beibehalten',
    benef_souhait_rapatriement: 'Zurückgeführt werden',
    docs_admin_title: 'Dokumente',
    docs_admin_generer_pdf: 'Mittelabruf-PDF erstellen',
    docs_admin_pdf_saved: 'PDF erstellt und gespeichert',
    docs_admin_ajouter: '+ Dokument hinzufügen',
    docs_admin_nom_label: 'Dokumentname',
    docs_admin_aucun: 'Kein Dokument erfasst.',
    docs_admin_appel_fonds: 'Mittelabruf',
    creer_acces_subtitle: "Erstellen Sie ein Konto, damit der Reisende seine Akte online vervollständigen kann.",
    creer_acces_voyageur: "Reisendenzugang erstellen",
    acces_email: "E-Mail des Reisenden",
    acces_password: "Temporäres Passwort",
    acces_generer: "Zugang erstellen",
    acces_cree: "Zugang erstellt — Zugangsdaten an den Reisenden weiterleiten",
    voyageur_space: "Mein Schadensbereich",
    voyageur_mon_dossier: "Meine Akte",
    err_required: "Reisebüro und Eröffnungsdatum sind erforderlich",
    warning_manager: "Die Freigabe muss von einem Manager bestätigt werden, bevor das Verfahren offiziell eröffnet wird. Diese Bestätigung sperrt das betroffene Reisebüro endgültig.",
  },

  collecte: {
    title: 'Risikoerklärung — Insolvenzversicherung',
    dr_ref: 'Referenz: DR-V-2401 · arcus-solutions.fr',
    section_renseignements: 'Allgemeine Angaben',
    nom_social: 'Name oder Firmenname *',
    nom_commercial: 'Handelsname (falls abweichend)',
    directeur: 'Direktor / Geschäftsführer',
    adresse: 'Adresse',
    forme_juridique: 'Rechtsform',
    capital_social: 'Stammkapital',
    siren: 'Handelsregisternummer',
    site_internet: 'Webseite',
    date_creation: 'Gründungsdatum',
    date_cloture: 'Datum des Geschäftsjahresendes',
    nb_agences: "Anzahl Filialen",
    nb_collaborateurs: 'Anzahl Mitarbeiter',
    immat_atout_france: "Atout-France-Nummer",
    rc_pro_numero: "Berufshaftpflichtnummer",
    rc_pro_compagnie: "Name der Versicherungsgesellschaft",
    rc_pro_echeance: 'Fälligkeit Berufshaftpflicht',
    banque_title: 'Hauptbank',
    ec_title: 'Steuerberater',
    correspondant: 'Ansprechpartner',
    section_dirigeants: 'Die Geschäftsführer',
    dir_nom: 'Nachname *',
    dir_formations: 'Berufliche Qualifikationen',
    dir_annees: "Berufserfahrung (Tourismus)",
    dir_pct: '% des Stammkapitals',
    dir_situations: "War der Geschäftsführer / Gesellschafter in einer dieser Situationen?",
    dir_sauvegarde: 'Schutzschirmverfahren',
    dir_redressement: 'Sanierungsverfahren',
    dir_liquidation: 'Liquidationsverfahren',
    dir_infos: 'Wichtige Informationen, die Sie uns mitteilen möchten',
    dir_add: '+ Geschäftsführer / Gesellschafter hinzufügen',
    dir_del: 'Löschen',
    dir_num: 'Geschäftsführer / Gesellschafter',
    section_patrimoine: 'Vermögen der Geschäftsführer',
    pat_nom: 'Name des Geschäftsführers',
    pat_estimation: 'Schätzung (€)',
    pat_type_immo: 'Art des Immobilienvermögens',
    pat_adresse_immo: 'Adresse der Immobilie',
    pat_type_mobilier: 'Art des beweglichen Vermögens',
    pat_prets: 'Laufende Kredite (€)',
    pat_etablissement: 'Kreditgeber',
    pat_capital: 'Investiertes Kapital (€)',
    pat_add: '+ Vermögen hinzufügen',
    section_societes: 'Informationen zu anderen Gesellschaften der Gesellschafter',
    soc_warning: "Bitte füllen Sie diese Tabelle aus und legen Sie den letzten Jahresabschluss jeder Struktur bei. Bei vorheriger Insolvenz bitte angeben.",
    soc_nom: 'Name / Firmenname',
    soc_associe: 'Verbundener Gesellschafter',
    soc_date: 'Gründungsdatum',
    soc_ca: 'Umsatz (N-1) €',
    soc_resultat: 'Jahresüberschuss (N-1) €',
    soc_add: '+ Gesellschaft hinzufügen',
    section_presentation: "Kurze Darstellung Ihrer Tätigkeit / des Projekts",
    description_label: "Beschreiben Sie Ihre Tätigkeit / Ihr Projekt *",
    description_placeholder: "Beschreibung der Tätigkeit oder des Gründungsprojekts…",
    reseau_label: "Sind Sie / werden Sie einem Netzwerk beitreten? Wenn ja, welchem?",
    reseau_placeholder: "Bsp. Selectour, Afat, Thomas Cook…",
    ca_title: "Aufteilung des Umsatzvolumens (€)",
    ca_forfaits_dist: "Pauschalreisen — Vertrieb (€)",
    ca_forfaits_prod: "Pauschalreisen — Produktion (€)",
    ca_prestations: "Touristische Einzelleistungen (€)",
    ca_transport: "Reiner Transport (€)",
    ca_total: "GESAMTES Umsatzvolumen (€)",
    clientele_btoc: "B2C-Kundschaft (Privatpersonen / Unternehmen / Betriebsräte)",
    clientele_btob: "B2B-Kundschaft (andere Tourismus-Fachleute)",
    clientele_autres: "Sonstige Kundschaft",
    mode_distrib: "Vertriebsart (Website, Filiale, Netzwerk…)",
    fournisseurs_label: "Hauptlieferanten (TO, Incoming, Hotels, DMC…)",
    fournisseurs_placeholder: "Bsp. Jet tours, Kuoni, Accor…",
    section_complement: "Zusätzliche Informationen",
    engagement_label: "Volumenverpflichtung gegenüber Ihren Lieferanten? Wenn ja, detaillieren",
    delais_label: "Zahlungsbedingungen / -fristen Lieferanten",
    repartition_monde: "Verteilung der Tätigkeit weltweit (%)",
    reglement_title: "Zahlungsart der Kunden (%)",
    reglement_especes: "Bargeld %",
    reglement_cheque: "Scheck %",
    reglement_virement: "Überweisung / Lastschrift %",
    reglement_carte: "Karte %",
    passerelle_label: "Nutzen Sie einen Payment Gateway (Merchant Acquirer)?",
    passerelle_nom: "Wenn ja, welchen",
    passerelle_delai: "Transferzeit der Mittel (Tage)",
    section_previsionnel: "Finanzplanung",
    pct_acompte: "% Anzahlung bei Buchung",
    mois_reservation: "Wie viele Monate im Voraus buchen die Kunden im Durchschnitt?",
    mois_solde: "Wie viele Monate vor Abreise wird der Restbetrag bezahlt?",
    montant_moyen: "Durchschnittsbetrag pro Reisendem (€)",
    previsionnel_title: "Umsatzprognose nach Abreisedatum — zu garantierender Zeitraum",
    previsionnel_desc: "Berücksichtigen Sie nur das Umsatzvolumen der durchgeführten Leistungen. Beispiel: Eine Gruppe von 10 Personen reist im Juli ab, das Umsatzvolumen beträgt 10 000 €, bitte im Juli 10 000 € angeben.",
    previsionnel_col1: "Monat / Jahr",
    previsionnel_col2: "Ursprünglich deklarierte Leistungen (€)",
    previsionnel_total: "GESAMT",
    previsionnel_hint: "Geben Sie den 1. Monat ein — die folgenden 11 Monate werden automatisch ausgefüllt",
  },

    rcpro_studies: {
    title: "RC-Pro-Zeichnungsanträge in Prüfung",
  },
  gf_studies: {
    title: "Akten in Prüfung",
    count: "Akte",
    count_plural: "Akten",
    empty: "Keine Akten in Prüfung.",
    col_client: "Kunde",
    col_broker: "Makler",
    col_submitter: "Eingereicht von",
    col_date: "Eingereicht am",
    col_actions: "Aktionen",
    study_btn: "Akte prüfen",
  },
  gf_declarations: {
    title: "Umsatzmeldungen",
    count: "Akte",
    count_plural: "Akten",
    empty: "Keine ausstehende Meldung.",
    col_client: "Kunde",
    col_broker: "Makler",
    col_period: "Gemeldeter Zeitraum",
    col_declared: "Gemeldet am",
    col_amount: "Ist / Prognose",
    col_actions: "Aktionen",
    review_btn: "Prüfen",
    over_forecast: "Über Prognose",
    vs_prev: "Prog.",
  },
  gf_requests: {
    title: "Anträge auf Eröffnung einer Finanzgarantie",
    count: "Antrag",
    count_plural: "Anträge",
    empty: "Keine ausstehenden Eröffnungsanträge.",
    col_client: "Kunde",
    col_broker: "Makler",
    col_requester: "Antragsteller",
    col_date: "Beantragt am",
    col_actions: "Aktionen",
    validate: "Genehmigen",
    refuse: "Ablehnen",
    refuse_title: "Antrag ablehnen",
    refuse_desc: "Geben Sie den Ablehnungsgrund an für",
    refuse_motif_ph: "Ablehnungsgrund (optional)",
    refuse_confirm: "Ablehnung bestätigen",
  },
  rcpro: {
    submit_btn: "Zeichnungsantrag übermitteln",
    submit_blocked_hint: "Laden Sie alle erforderlichen Zeichnungsunterlagen hoch, um zu übermitteln.",
    submit_missing_title: "Um Ihren Zeichnungsantrag zu übermitteln, fehlt noch:",
    submit_missing_docs: "Hochzuladende Zeichnungsunterlagen.",
    submitted_banner: "Zeichnungsantrag an Arcus Solutions übermittelt — in Prüfung. Das Formular ist während der Prüfung gesperrt.",
    submit_confirm_title: "Zeichnungsantrag übermitteln?",
    submit_confirm_desc: "Ihr Antrag (Zeichnungsunterlagen) wird zur Prüfung an das Arcus-Solutions-Team gesendet. Das Formular wird während der Prüfung gesperrt. Sie werden über das Ergebnis informiert.",
    submit_confirm_btn: "Übermitteln",
  },
  notes_int: {
    open: "Interne Diskussion",
    title: "Interne Diskussion",
    scope_client: "Verlauf zu diesem Kunden",
    scope_police: "Verlauf zu diesem Vertrag",
    empty: "Noch keine internen Notizen. Fügen Sie einen Kommentar hinzu, um die Historie zu starten.",
    placeholder: "Internen Kommentar hinzufügen…",
    attach: "Dateien anhängen",
    drop_here: "Dateien hier ablegen",
    hint: "Datei oder E-Mail per Drag & Drop · Strg+Enter zum Senden",
    readonly: "Nur Ansicht für dieses Profil.",
    delete_confirm: "Diesen Kommentar löschen?",
  },
  gf: { submit_btn: "Akte an Arcus übermitteln", submit_blocked_hint: "Füllen Sie die Datenerfassung aus und laden Sie alle erforderlichen Dokumente hoch, um zu übermitteln.", submit_missing_title: "Um Ihre Akte an Arcus Solutions zu übermitteln, fehlt noch:", submit_missing_collecte: "Fehlende Pflichtangaben (Datenerfassung):", submit_missing_docs: "Hochzuladende Zeichnungsunterlagen.", submitted_banner: "Akte an Arcus Solutions übermittelt — in Prüfung. Das Formular ist während der Prüfung gesperrt.", submit_confirm_title: "Akte an Arcus Solutions übermitteln?", submit_confirm_desc: "Ihre Akte (Erfassung + Dokumente) wird zur Prüfung an das Arcus-Solutions-Team gesendet. Das Formular wird während der Prüfung gesperrt. Sie werden über das Ergebnis informiert.", submit_confirm_btn: "Übermitteln", request_open_btn: "Eröffnung einer Finanzgarantie-Akte beantragen", request_done_msg: "Ihr Antrag auf Akteneröffnung wurde an das Arcus-Solutions-Team übermittelt, das sich zur Bearbeitung schnellstmöglich bei Ihnen melden wird.", awaiting_validation: "Warten auf Validierung",
    tab_surveillance: "Risikoüberwachung",
    surveillance_intro_title: "Verfolgung des tatsächlichen Umsatzes",
    surveillance_intro_text: "In regelmäßigen Abständen meldet der Kunde seinen tatsächlichen Umsatz, um die Übereinstimmung mit der Prognose zu überprüfen. Diese Daten fließen in die Überwachung des Garantiefonds ein.",
    surveillance_frequency_label: "Überwachungsfrequenz",
    surveillance_freq_trim: "Vierteljährlich",
    surveillance_freq_sem: "Halbjährlich",
    surveillance_freq_not_set: "Nicht festgelegt",
    surveillance_pick_freq: "Wählen Sie die Überwachungsfrequenz aus, um die Meldeperioden zu generieren.",
    surveillance_not_subscribed: "Die Meldeperioden werden mit Abschluss der Police generiert.",
    surveillance_period: "Periode",
    surveillance_declaration_in: "Meldung erwartet im",
    surveillance_col_month: "Monat",
    surveillance_col_previsionnel: "Prognose",
    surveillance_col_realise: "Tatsächliche Leistungen",
    surveillance_col_ecart: "Abweichung",
    surveillance_total: "Gesamt",
    surveillance_declared_at: "Gemeldet am",
    surveillance_validated_at: "Freigegeben am",
    surveillance_declare_btn: "An Arcus Solutions melden",
    surveillance_validate_btn: "Meldung freigeben",
    surveillance_status_a_venir: "Bevorstehend",
    surveillance_status_a_declarer: "Zu melden",
    surveillance_status_declaree: "Gemeldet",
    surveillance_status_validee: "Freigegeben",
    surveillance_reset_title: "Frequenz ändern?",
    surveillance_reset_warning: "Die Änderung der Frequenz wird die bestehenden Perioden sowie alle bereits erfassten Meldungen löschen. Diese Aktion ist unwiderruflich.",
    surveillance_reset_confirm: "Bestätigen und zurücksetzen",
    create_variation: "Variation erstellen",
    renew_procedure: "Verlängerungsverfahren erstellen",
    terminate_gf: "Kündigen",
    title: 'Insolvenzversicherung',
    nav: 'Insolvenzversicherung',
    tab_policy: 'Die Police',
    tab_tarification_gf: 'Tarifierung',
    tarif_add_period: '+ Periode hinzufügen',
    tarif_period: 'Periode',
    tarif_date_debut: 'Startdatum',
    tarif_date_fin: 'Enddatum',
    tarif_exposition: 'Exposition (€)',
    tarif_taux: 'Satz (%)',
    tarif_prime_ht: 'Nettoprämie',
    tarif_taxe: 'Steuer (9%)',
    tarif_prime_ttc: 'Bruttoprämie',
    tarif_total: 'GESAMTBRUTTOPRÄMIE',
    tarif_hint: 'Nettoprämie = Exposition × Satz · Steuer = 9% · Bruttoprämie = Nettoprämie + Steuer',
    tab_underwriting: 'Informationssammlung',
    tab_documents: 'Dokumente',
    tab_souscription: 'Abschlussunterlagen',
    create_policy: '+ Neue GF-Police',
    portfolio_title: 'Insolvenzversicherungs-Portfolio',
    contexte_label: 'Kontext der Anfrage *',
    contexte_creation: "Unternehmensgründung",
    contexte_historique: 'Bestehendes Unternehmen',
    contexte_ajout: "Hinzufügen einer Tourismustätigkeit",
    contexte_hint_creation: 'Unternehmen in Gründung — 7 Dokumente erforderlich',
    contexte_hint_existant: 'Bestehendes Unternehmen — 10 Dokumente erforderlich',
    collecte_title: 'Risikoerklärung — Insolvenzversicherung',
    tarification_placeholder_sub: 'Die Parameter werden in einer zukünftigen Version konfiguriert.',
    warn_date_effet_locked: "Änderung möglich aber sensibel — denken Sie daran, die Überwachungsperioden bei Bedarf zurückzusetzen",
    // ── Payment Graph (onglet Arcus) ──
    tab_payment_graph: "Payment Graph",
    pg_title: "Bond Graph — Theoretische Exposition",
    pg_subtitle: "Automatische Berechnung von Risiko und Prämie aus der Finanzprognose.",
    pg_incomplete: "Vervollständigen Sie die „Finanzprognose“ (Umsatztabelle) im Reiter Informationserfassung, um den Bond Graph zu erzeugen.",
    pg_params_title: "Parameter aus der Erfassung",
    pg_param_acompte: "Anzahlung",
    pg_param_solde: "Restzahlung",
    pg_param_reserv: "Buchung im Voraus",
    pg_param_solde_delai: "Restzahlung vor Abreise",
    pg_months: "Monate",
    pg_total_bookings: "Umsatz (Jahr 1)",
    pg_param_missing: "Geben Sie den Anzahlungs-% und die Anzahl der Monate der Vorausbuchung in der Erfassung für eine zuverlässige Berechnung an.",
    pg_admin_title: "Berechnungsparameter (Arcus)",
    pg_rate: "Prämiensatz (%)",
    pg_bond_helper: "Hilfen zur Bond-Level-Berechnung (Umsatz × %)",
    pg_col_month: "Monat",
    pg_col_bookings: "Bookings departing",
    pg_col_cash_received: "Cash Received",
    pg_col_cash_held: "Cash Held",
    pg_col_exposure: "Exposure",
    pg_col_last_bond: "Bond N-1",
    pg_col_bond: "Bond level",
    pg_col_premium: "Premium",
    pg_year1_tag: "J1",
    pg_year2_tag: "J2 · Projektion",
    pg_total_year1: "GESAMT — Jahr 1",
    pg_annual_ht: "Jahresnettoprämie",
    pg_peak_exposure: "Max. Exposition (Jahr 1)",
    pg_annual_ttc: "Jahresbruttoprämie",
    pg_formula_cash: "Anzahlung × Bookings(Monat+Vor) + Rest × Bookings(Monat+Rest)",
    pg_formula_premium: "Bond level × Satz ÷ 12 · Brutto = Netto × 1,09 (9% Steuer)",
    pg_last_bond_hint: "Bond N-1: in Jahr 1 leer · bei Verlängerung automatisch gefüllt (Exposition des Vorjahres).",
    // ── Lot 1 : cotation + sections Documents ──
    pg_cotation_title: "Angebot (Versicherungsentwurf)",
    pg_cotation_empty: "Keine Angebotsperiode definiert.",
    pg_generate_cotation: "Angebot erstellen",
    pg_regenerate_cotation: "Angebot neu erstellen",
    pg_cotation_generated: "Angebot erstellt am",
    pg_cotation_none: "Kein Angebot erstellt",
    pg_cotation_confirm_title: "Angebot erstellen?",
    pg_cotation_confirm_desc: "Das Angebot wird gespeichert und der Versicherungsentwurf wird im Reiter Dokumente verfügbar.",
    pg_cotation_confirm_btn: "Erstellen",
    doc_section_projet: "Versicherungsentwurf",
    doc_section_contractuelles: "Vertragsdokumente",
    doc_projet_ready: "Angebot vom",
    doc_projet_locked: "Erstellen Sie das Angebot im Reiter Payment Graph, um den Versicherungsentwurf zu aktivieren.",
    doc_projet_badge_todo: "Zu erstellen",
    // ── Lot 3 : déclarations + variations ──
    pg_col_declarations: "Declarations",
    pg_period_declared: "Gemeldeter Zeitraum",
    pg_period_vs: "vs Prog.",
    pg_over_forecast: "Über Prognose",
    pg_create_variation: "Variation erstellen",
    pg_variation_created: "Variation erstellt",
    pg_variations_title: "Prämienvariationen",
    pg_variation_label: "Variation",
    pg_variation_badge_draft: "Entwurf",
    pg_variation_badge_done: "Erstellt",
    pg_variation_generate: "Prämienabruf für Variation erstellen",
    pg_variation_regenerate: "Prämienabruf neu erstellen",
    pg_variation_generated: "Prämienabruf erstellt am",
    pg_variation_confirm_title: "Prämienabruf für Variation erstellen?",
    pg_variation_confirm_desc: "Der Prämienabruf für die Variation wird gespeichert und erscheint im Reiter Dokumente unter den Vertragsdokumenten.",
    pg_variation_confirm_btn: "Erstellen",
    doc_section_variations: "Prämienabrufe für Variationen",
    doc_variation_label: "Prämienabruf für Variation",
    // ── Workflow étude/police GF ──
    etude_title: "Fallprüfung",
    etude_locked_note: "Abschnitt gesperrt — die Police ist abgeschlossen.",
    numero_projet: "Projektnummer",
    date_effet_prev: "Voraussichtliches Wirksamkeitsdatum",
    date_prev_locked_devis: "Nach Angebotsphase gesperrt.",
    step_hint_demande_pieces: "Der Kunde vervollständigt seine Akte und übermittelt sie an Arcus.",
    step_hint_en_cours: "Automatisch erreicht, wenn der Kunde seine Akte übermittelt.",
    step_hint_devis: "Erreicht, wenn der Versicherungsentwurf erstellt wird.",
    repasser_btn: "Zurück zu Unterlagenanforderung",
    repasser_confirm_title: "Akte zurück zu Unterlagenanforderung setzen?",
    repasser_confirm_desc: "Das Formular wird für den Kunden wieder bearbeitbar; bereits eingegebene Daten bleiben erhalten. Die Akte kehrt zum Status „Unterlagenanforderung“ zurück.",
    repasser_confirm_btn: "Zurücksetzen",
    police_locked_note: "Abschnitt wird beim Abschluss der Police aktiviert.",
    // ── Souscription GF ──
    souscrire_btn: "Police abschließen",
    souscrire_need_date: "Wirksamkeitsdatum angeben.",
    souscrire_confirm_title: "Police abschließen",
    souscrire_confirm_desc: "Bestätigen Sie die Angaben unten, um die Police zu erstellen. Der Abschnitt „Police“ wird aktiviert und die Fallprüfung gesperrt.",
    souscrire_date_label: "Wirksamkeitsdatum der Police",
    souscrire_npolice_label: "Policennummer",
    souscrire_freq_label: "Monitoring-Frequenz",
    souscrire_freq_hint: "Diese Wahl sperrt die Frequenz im Reiter Risk Monitoring.",
    souscrire_confirm_btn: "Abschließen",
    // ── Tableau parallèle déclarations ──
    pg_group_original: "Payment Graph (Prognose)",
    pg_group_declarations: "Meldungsverfolgung",
    pg_col_updated_exposure: "Updated exposure",
    pg_col_updated_bond: "Updated bond level",
    // ── Lot 1 : bond level par périodes ──
    pg_define_bond: "Bond-Level festlegen",
    pg_bond_modal_title: "Bond-Level für einen Zeitraum festlegen",
    pg_bond_modal_desc: "Der Zeitraum beginnt im ersten nicht abgedeckten Monat. Wählen Sie Endmonat und Betrag: jeder Monat des Zeitraums erhält dieses Bond-Level.",
    pg_bond_modal_confirm: "Zeitraum festlegen",
    pg_bond_period_start: "Beginn (auto)",
    pg_bond_period_end: "Ende des Zeitraums",
    pg_bond_amount: "Bond-Level-Betrag",
    pg_bond_expo_max: "Max. Exposure verwenden:",
    pg_bond_periods_recap: "Bond-Level-Zeiträume",
    pg_bond_periods_none: "Kein Zeitraum definiert – im ersten Monat auf „Bond-Level festlegen“ klicken.",
    pg_bond_periods_incomplete: "12 Monate noch nicht abgedeckt",
    pg_bond_remove_last: "Letzten entfernen",
    pg_bond_reset: "Zurücksetzen",
    // ── Lot 2 : cotation auto ──
    pg_cotation_auto_hint: "Das Angebot wird automatisch aus den Bond-Level-Zeiträumen erzeugt (Daten + Exposure + Satz).",
    pg_cotation_need_bond: "Definieren Sie zuerst die Bond-Level-Zeiträume in der Tabelle oben.",
    pg_cotation_incomplete: "Decken Sie alle 12 Monate mit Bond-Level-Zeiträumen ab und geben Sie den Satz an, um das Angebot zu erzeugen.",
    // ── Lot 3 : déclarations mois futurs ──
    surveillance_anticipation_hint: "Vorwegnahme möglich — bearbeitbar bis zur Meldung, dann gesperrt.",
    // ── Lot 4 : section variations ──
    pg_variations_hint: "Variationen werden automatisch aus validierten Mehrmeldungen berechnet, aufgeteilt nach Bond-Level-Zeitraum.",
    pg_var_peakbond_title: "Peak-Bond % pro Zeitraum",
    pg_var_period: "Zeitraum",
    pg_var_peakbond: "Peak-Bond %",
    pg_var_booking_initial: "Booking Departing initial",
    pg_var_booking_new: "Neues Booking Departing",
    pg_var_increase: "Anstieg",
    pg_var_none: "Keine Variation — noch keine validierte Mehrmeldung.",
    pg_var_value: "Variationswert",
    pg_var_days: "Tage",
    pg_variation_see_section: "→ siehe Abschnitt Variationen",
    pg_chart_title: "Bond graph — Kurven",
    surveillance_declare_confirm_title: "An Arcus Solutions melden?",
    surveillance_declare_confirm_desc: "Die untenstehenden Volumina werden zur Validierung an Arcus Solutions übermittelt. Nach Bestätigung wird dieser Zeitraum dauerhaft gesperrt und kann nicht mehr geändert werden.",
    surveillance_declare_confirm_btn: "Meldung bestätigen",
    pg_var_appel_title: "Prämiennachforderung (Variation)",
    pg_var_appel_pending_desc: "Die untenstehenden ausstehenden Variationen werden in einer einzigen Prämiennachforderung zusammengefasst.",
    pg_var_appel_none: "Keine Variation wartet auf eine Prämiennachforderung.",
    pg_var_appel_generate: "Prämiennachforderung erstellen",
    pg_var_appel_history: "Erstellte Nachforderungen",
    pg_var_appel_confirm_title: "Prämiennachforderung erstellen?",
    pg_var_appel_confirm_desc: "Wählen Sie die Variationen aus, die in diese Prämiennachforderung aufgenommen werden sollen. Nicht angekreuzte Variationen bleiben für eine spätere Nachforderung ausstehend.",
    pg_var_appel_confirm_btn: "Nachforderung erstellen",
    pg_var_badge_covered: "Enthalten in der Nachforderung vom",
    pg_var_badge_pending: "Wartet auf Nachforderung",
    pg_table_title: "Payment graph",
    surveillance_declare_validate_btn: "Melden und validieren",
    surveillance_declare_validate_desc: "Sie melden diese Volumina im Namen des Kunden: Der Zeitraum wird sofort gemeldet UND validiert und anschließend dauerhaft gesperrt. Der Payment Graph wird aktualisiert.",
    pf_title: "Portfolio Finanzielle Garantie",
    pf_contracts: "Akten",
    pf_col_month: "Erstellungsmonat",
    pf_col_status: "Status",
    pf_col_name: "Akte",
    pf_col_country: "Land",
    pf_col_broker: "Makler",
    pf_col_prev_date: "Voraussichtl. Datum",
    pf_direct: "Direkt",
    pf_search: "Kunde / Policennr.…",
    pf_filter: "Filtern",
    pf_filter_search: "Suchen…",
    pf_filter_all: "Alle auswählen",
    pf_filter_none: "Alle abwählen",
    pf_filter_clear_all: "Alle Filter löschen",
    pf_no_rows: "Keine Akte entspricht den Filtern.",
    pg_mgmt_fees: "Verwaltungsgebühren",
  },



  account: {
    title: "Mein Konto",
    breadcrumb: "PERSÖNLICHER BEREICH",
    profile: "Mein Profil",
    change_password: "Passwort ändern",
    current_password: "Aktuelles Passwort",
    update_password_btn: "Passwort aktualisieren",
    password_changed: "Passwort erfolgreich geändert.",
    field_nom: "Vollständiger Name",
    field_email: "E-Mail",
    field_role: "Status",
  },
  utilisateurs: { col_last_login: "Letzte Anmeldung", never_connected: "Noch nie angemeldet",
    create_mode_label: "Methode zur Kontoerstellung",
    mode_link: "Aktivierungslink senden",
    mode_password: "Passwort festlegen",
    password_label: "Passwort",
    password_ph: "Mindestens 8 Zeichen",
    password_info: "Das Konto ist mit diesem Passwort sofort nutzbar. Es wird keine E-Mail gesendet.",
    pwd_too_short: "Das Passwort muss mindestens 8 Zeichen enthalten.",
    title: "Benutzerkonten",
    count: "Konto",
    count_plural: "Konten",
    create_btn: "+ Benutzer erstellen",
    search_placeholder: "Suche nach Name oder E-Mail…",
    filter_all: "Alle",
    statut_actif: "Aktiv",
    statut_inactif: "Inaktiv",
    breadcrumb: "BENUTZERKONTEN",
    new_title: "Neues Konto",
    edit_title: "Konto bearbeiten",
    field_nom: "Vollständiger Name",
    field_email: "E-Mail",
    field_role: "Status (Rolle)",
    field_client: "Zugewiesener Kunde",
    field_courtier: "Zugeordneter Makler",
    field_statut: "Kontostatus",
    create_info: "Eine Aktivierungs-E-Mail wird an die angegebene Adresse gesendet. Der Benutzer legt sein Passwort über den erhaltenen Link fest.",
    create_and_send: "Erstellen und Link senden",
    send_reset: "Zurücksetzungslink senden",
    reset_password: "Passwort zurücksetzen",
    reset_sent_simple: "Zurücksetzungslink gesendet",
    saved: "Änderungen gespeichert",
    created: "Konto erstellt — E-Mail gesendet",
    delete_confirm: "Konto endgültig löschen von",
  },
  docs_souscription: {
    title: 'Abschlussunterlagen',
    subtitle: 'Vor Vertragsabschluss zu sammelnde Unterlagen',
    doc_projet_signe: "Unterzeichneter Versicherungsentwurf",
    doc_certificat: "Handelsregisterauszug",
    doc_rib: 'Bankverbindung',
    doc_releve_sinistre: 'Schadensauszug',
    rib_condition: 'Erforderlich — unterjährige Zahlung',
    releve_condition: 'Erforderlich — Risiko bereits versichert',
    add_doc: '+ Erforderliches Dokument hinzufügen',
    add_doc_placeholder: "Bsp. Bescheinigung des Vorversicherers",
    add_doc_label: 'Dokumentbezeichnung',
    upload_btn: 'Hochladen',
    replace_btn: 'Ersetzen',
    preview_btn: 'Anzeigen',
    accept_btn: 'Annehmen',
    refuse_btn: 'Ablehnen',
    status_attente: 'Wartend',
    status_uploade: 'Hochgeladen',
    status_accepte: 'Angenommen',
    status_refuse: 'Abgelehnt',
    refuse_category: 'Ablehnungskategorie *',
    refuse_category_placeholder: '— Kategorie auswählen —',
    refuse_detail: 'Genauere Angabe (optional)',
    refuse_email_btn: '📧 Ablehnungs-E-Mail an den Kunden senden',
    refuse_email_title: 'E-Mail — Abgelehnte Dokumente',
    refuse_email_copy: 'Kopieren',
    refuse_email_open: 'In E-Mail-Programm öffnen',
    refuse_email_copied: 'Kopiert!',
    refuse_email_subject: 'Ihre Akte — Zu regulierende Dokumente',
    refuse_no_refused: 'Keine abgelehnten Dokumente bisher.',
    refuse_title: 'Begründung der Ablehnung',
    refuse_label: 'Ablehnungsgrund *',
    refuse_placeholder: "Bsp.: Unleserliches Dokument, falsches Dokument…",
    refuse_email_note: 'Dieser Kommentar wird per E-Mail an den Kunden gesendet.',
    refuse_confirm: 'Ablehnung bestätigen',
    locked_msg: 'Angenommen',
    rejected_comment: 'Grund:',
    completion: 'akzeptiert',
    accept_confirm: 'Dieses Dokument annehmen?',
    file_size: 'Max 20 MB — PDF, Bilder, Word',
    unlock_btn: 'Entsperren',
    unlock_confirm: 'Dieses Dokument wieder zur Prüfung freigeben?',
    doc_gf_cert_immat: "Handelsregisterauszug",
    doc_gf_statuts: "Gesellschaftssatzung",
    doc_gf_cv_dirigeant: 'Lebenslauf des Geschäftsführers',
    doc_gf_piece_id: "Ausweisdokument des Geschäftsführers",
    doc_gf_presentation_projet: 'Projektpräsentation',
    doc_gf_previsionnel: "Detaillierte Geschäftsprognose",
    doc_gf_cgv: 'Allgemeine Geschäftsbedingungen',
    doc_gf_presentation_activites: 'Tätigkeitspräsentation',
    doc_gf_previsionnel_annuel: "Geschäftsprognose für das zu sichernde Jahr",
    doc_gf_bilan_cr: 'Letzter Jahresabschluss und detaillierte GuV',
    doc_gf_attestation_rcpro: 'Aktuelle Berufshaftpflichtbescheinigung',
    doc_gf_attestation_fonds: 'Bescheinigung über gehaltene Spitzenbeträge',
    readonly_banner: 'Nur-Lese-Ansicht — Hochladen und Anzeigen',
    broker_readonly: 'Als Makler können Sie die Kundenakten nur ansehen.',
    address_siege: 'Hauptsitzadresse',
    broker_status_locked: 'Interessent — Status wird vom Arcus-Sachbearbeiter festgelegt',
    accepted_label: 'akzeptiert',
    required_label: 'Erforderlich',
    delete_btn: '🗑 Löschen',
    doc_contrat_reservation: "Kopie des Buchungsvertrags mit dem Reisebüro",
    doc_preuve_paiement: 'Zahlungsnachweis(e)',
    doc_bon_voucher: 'Nicht eingelöster Gutschein / Voucher (falls vorhanden)',
    delete_confirm: 'Dieses Dokument löschen?',
    // ── Verrou pack + ZIP (Lot C) ──
    lock_pack: "Unterlagen sperren",
    unlock_pack: "Unterlagen entsperren",
    generate_zip: "ZIP-Paket erstellen",
    lock_confirm: "Unterlagenpaket sperren? Bis zur Entsperrung sind keine Änderungen mehr möglich.",
    unlock_pack_confirm: "Unterlagenpaket entsperren, um Änderungen zuzulassen?",
    zip_confirm: "ZIP des Unterlagenpakets erstellen?",
    zip_coming: "ZIP-Erstellung folgt in Kürze.",
    pack_locked_note: "Unterlagen gesperrt.",
    pack_ready_note: "Alle erforderlichen Unterlagen sind validiert.",
  },
  chat: {
    open: "Chat öffnen",
    minimize: "Minimieren",
    with_arcus: "Unterhaltung mit Arcus",
    no_conv: "Keine Unterhaltung",
    select_conv: "Wählen Sie eine Unterhaltung aus",
    no_conv_yet: "Noch keine Unterhaltung",
    no_messages_yet: "Keine Nachrichten",
    send_first_message: "Senden Sie unten Ihre erste Nachricht",
    message_placeholder: "Nachricht schreiben…",
    participants: "Mitglieder",
    you: "Sie",
    add: "Hinzufügen",
    add_admin: "Arcus-Mitglied hinzufügen",
    remove_participant: "Dieses Mitglied entfernen",
    confirm_remove_participant: "Dieses Mitglied aus der Unterhaltung entfernen?",
    all_admins_already: "Alle Admins sind bereits Mitglieder",
    loading_error: "Unterhaltung nicht verfügbar",
    back_list: "Zurück zu den Unterhaltungen",
  },
  it_delete: {
    title: "God Mode — Erzwungene Löschung",
    god_mode: "GOD MODE — IT",
    entity_client: "Kunde",
    entity_police: "Police",
    entity_intermediaire: "Vermittler",
    about_to_delete: "Sie sind dabei, endgültig zu löschen",
    also_deleted: "VERKNÜPFTE ELEMENTE IN KASKADE GELÖSCHT",
    no_cascade: "Keine verknüpften Elemente zu löschen.",
    polices: "Policen",
    amendements: "Nachträge",
    renouvellements: "Verlängerungen (Verknüpfungen entfernt)",
    clients_unlinked: "Verknüpfte Kunden (werden direkt)",
    irreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    confirm_btn: "Endgültig löschen",
    impact_error: "Auswirkung konnte nicht berechnet werden.",
    delete_error: "Löschung fehlgeschlagen.",
    dossiers_linked: "Verknüpfte Akten (Zahlungen betroffen)",
  },

  prestataires_section: {
    title: "Dienstleister & Reiseveranstalter",
    breadcrumb: "DIENSTLEISTER",
    count: "Dienstleister",
    count_plural: "Dienstleister",
    contacts_count: "Kontakt",
    contacts_count_plural: "Kontakte",
    create_btn: "+ Neuer Dienstleister",
    new_title: "Neuer Dienstleister",
    search_placeholder: "Suche nach Name, Stadt, Unternehmensnummer…",
    iban_set: "IBAN hinterlegt",
    tab_infos: "Der Dienstleister",
    tab_contacts: "Kontakte",
    tab_bank: "Bankinformationen",
    field_nom: "Name des Dienstleisters",
    field_adresse_1: "Adresse 1",
    field_adresse_2: "Adresse 2",
    field_code_postal: "PLZ",
    field_ville: "Stadt",
    field_numero_entreprise: "Unternehmensnummer",
    field_notes: "Interne Notizen",
    field_numero_compte: "Kontonummer",
    field_iban: "IBAN",
    field_swift: "SWIFT- / BIC-Code",
    adresse_placeholder: "Hausnummer und Straße",
    numero_placeholder: "USt-ID, Steuernummer…",
    notes_placeholder: "Nützliche Infos: Geschäftsart, Zahlungsbedingungen…",
    bank_warning: "Diese Daten werden automatisch verwendet, wenn Schadensfälle mit Reisefortführung bezahlt werden.",
    err_nom: "Der Name des Dienstleisters ist erforderlich.",
  },

  phase_b: {
    count: "Akte",
    count_plural: "Akten",
    empty: "Keine Akte in dieser Kategorie.",
    col_numero: "Akten- / Verfahrens-Nr.",
    col_agence: "Reisebüro",
    col_beneficiaire: "Begünstigter",
    col_montant: "Betrag",
    col_date_action: "Datum",
    col_par: "Von",
    confirm_title: "Aktion bestätigen?",
    refus_banner_title: "Akte vom Manager abgelehnt — Grund:",
    send_validation_title: "An Manager zur Freigabe senden",
    send_validation_desc: "Nach dem Senden wartet die Akte auf die Manager-Freigabe vor der Zahlung.",
    send_validation_btn: "Zur Freigabe senden",
    manager_validation_title: "Manager-Freigabe erforderlich",
    manager_validation_desc: "Diese Akte ist bereit für die finale Freigabe vor Weitergabe an Accounts.",
    validate_btn: "Freigeben",
    refuse_btn: "Ablehnen",
    refuse_modal_title: "Ablehnungsgrund",
    refuse_modal_desc: "Die Akte kehrt in den Status \"In Bearbeitung\" zurück. Der Grund ist für den Admin sichtbar.",
    refuse_motif_placeholder: "Geben Sie den Ablehnungsgrund an…",
    refuse_confirm_btn: "Ablehnung bestätigen",
    ready_to_pay_title: "Bereit zur Zahlung",
    ready_to_pay_desc: "Manager hat diese Akte freigegeben. Accounts kann die Zahlung jetzt als erledigt markieren.",
    mark_paid_btn: "Als bezahlt markieren",
    mark_paid_confirm_title: "Zahlung erledigt bestätigen?",
    mark_paid_confirm_desc: "Nach Bestätigung geht die Akte in den Status \"Zahlung erledigt\" und wird gesperrt.",
    mark_paid_confirm_btn: "Zahlung bestätigen",
  },
  pending_validation: {
    title: "Wartet auf Manager-Freigabe",
    subtitle: "Von Admins gesendete Akten, die auf die finale Freigabe durch einen Manager warten.",
  },
  pending_payment: {
    title: "Wartet auf Zahlung",
    subtitle: "Vom Manager freigegebene Akten, die auf die Zahlung durch Accounts warten.",
    action_mark_paid: "Als bezahlt markieren",
    confirm_mark_paid: "Diese Akte als bezahlt markieren:",
    download_btn: "Datei der ausstehenden Zahlungen generieren",
  },
  pending_balances: { col_received: "Erhalten", col_remaining: "Restbetrag",
    title: "Ausstehende Salden",
    subtitle: "Von Reisenden noch einzuziehende Restbeträge",
    download_btn: "Excel-Datei erstellen",
    downloading: "Wird erstellt…",
    empty: "Noch kein Mittelabruf erstellt.",
    paid: "Bezahlt",
    unpaid: "Ausstehend",
    col_file: "Akte-Nr.",
    col_agency: "Reisebüro",
    col_beneficiary: "Begünstigter",
    col_generated: "Erstellt am",
    col_deadline: "Frist",
    col_balance: "Offener Saldo",
    col_paid: "Status",
  },
  closed_dossiers: {
    title: "Abgeschlossene Akten",
    subtitle: "Bezahlte und abgeschlossene Akten.",
    download_btn: "Schadensbericht herunterladen",
  },

  phase_c: {
    section_title: "Zu zahlende Dienstleister (Reise wird beibehalten)",
    section_subtitle: "Wählen Sie einen oder mehrere Dienstleister, damit der Kunde die Reise antreten kann.",
    add_prestataire: "Dienstleister hinzufügen",
    prestataire_num: "Dienstleister ",
    select_prestataire: "Dienstleister",
    select_placeholder: "Dienstleister auswählen",
    amount: "Betrag",
    reference: "Zahlungsreferenz",
    reference_placeholder: "Bsp. Rechnung Nr…",
    description: "Beschreibung",
    description_placeholder: "Bsp. Hotel 2 Nächte, Rückflug…",
    bank_locked: "Bankdaten (gesperrt — aus zentralem Dienstleisterprofil)",
    location: "Standort",
    total: "Gesamtbetrag Dienstleisterzahlungen",
    empty: "Kein Dienstleister hinzugefügt. Klicken Sie auf „Dienstleister hinzufügen\" um zu starten.",
  },

  voyageur_intro: {
    title: "Willkommen in Ihrem Schadensmeldungsbereich",
    body: "Vervollständigen Sie die Informationen zu Ihrer Reiseakte und übermitteln Sie die zur Bearbeitung Ihres Antrags erforderlichen Unterlagen.",
    submit_title: "Ist Ihre Akte vollständig?",
    submit_desc: "Nach der Übermittlung wird Ihre Akte zur Bearbeitung an unsere Teams gesendet.",
    submit_btn: "Meine Akte einreichen",
    submit_confirm_title: "Ihre Akte einreichen?",
    submit_confirm_desc: "Prüfen Sie, ob alle Ihre Informationen und Belege korrekt sind. Nach der Einreichung wird Ihre Akte in Bearbeitung übergehen.",
    submit_confirm_btn: "Einreichung bestätigen",
    status_section: "Status Ihrer Akte",
    status_msg_attente: "Wir warten darauf, dass Sie Ihre Informationen vervollständigen, Ihre Belege übermitteln und dann Ihre Akte einreichen.",
    status_msg_traitement: "Ihre Akte wird von unseren Teams bearbeitet. Sie werden über den Fortschritt informiert.",
    status_msg_validation: "Ihre Akte wartet auf die endgültige Freigabe durch unser Team.",
    status_msg_paiement: "Ihre Akte wurde freigegeben. Die Zahlung wird bearbeitet.",
    status_msg_solde_paye: "Der Saldo ist eingegangen. Ihre Akte wird weiter bearbeitet.",
    status_msg_realise: "Die Zahlung wurde durchgeführt. Ihre Akte ist abgeschlossen.",
    status_msg_decline: "Leider konnte Ihre Akte nicht angenommen werden. Kontaktieren Sie uns für weitere Informationen.",
  },

  phase_d4: {
    lock: "Sperren",
    unlock: "Entsperren",
    locked: "Gesperrt",
    lock_paiements: "Zahlungen sperren",
    unlock_paiements: "Zahlungen entsperren",
    date_naissance: "Geburtsdatum des Begünstigten",
    sanction_title: "Sanktionsprüfung",
    sanction_btn: "Sanktionsprüfung durchgeführt",
    sanction_done: "Sanktionsprüfung durchgeführt — die Zahlungen sind gesperrt.",
    sanction_undo: "Sperre aufheben (Manager)",
    validation_checklist: "Bedingungen für die Freigabeanfrage",
    cond_paiements_locked: "Zahlungen gesperrt",
    cond_docs_approved: "Alle Belege genehmigt",
    cond_sanction: "Sanktionsprüfung durchgeführt",
    cond_facture: "Dienstleisterrechnung(en) hochgeladen",
    cond_appel_fonds_paye: "Mittelabruf als bezahlt markiert",
    request_validation_title: "Freigabe der Akte anfordern",
    request_validation_desc: "Alle Bedingungen sind erfüllt. Die Akte wird gesperrt und an den Manager gesendet.",
    request_validation_btn: "Freigabe anfordern",
    validation_locked_hint: "Die Schaltfläche zur Freigabeanfrage erscheint, sobald alle obigen Bedingungen erfüllt sind.",
    decline_btn: "Akte ablehnen",
    decline_modal_title: "Diese Akte ablehnen?",
    decline_modal_desc: "Die Akte erhält den Status „Abgelehnt\" und wird geschlossen. Sie können einen Grund angeben.",
    decline_motif_placeholder: "Ablehnungsgrund (optional)…",
    decline_confirm_btn: "Ablehnung bestätigen",
  },
  phase_d4_facture: {
    title: "Dienstleisterrechnung",
    upload: "Rechnung hochladen",
    replace: "Ersetzen",
   view: "Ansehen", save_row_first: "Speichern Sie zuerst diesen Dienstleister, um seine Rechnung anzuhängen.",},
  phase_d5: {
    marquer_paye: "Als bezahlt markieren",
    annuler_paye: "Zahlung stornieren",
    paye_badge: "Bezahlt",
  },
  phase_solde: { af_confirm_btn: "Versand des Mittelabrufs bestätigen", af_confirm_title: "Versand des Mittelabrufs bestätigen?", af_confirm_desc: "Diese Aktion setzt den Fall auf „Warten auf Restzahlung“, zeigt dauerhaft den Bereich Saldoverwaltung an und sperrt die Erstellung eines neuen Mittelabrufs. Unwiderruflich.", af_confirmed_badge: "Mittelabruf bestätigt",
    admin_valid_title: "Validierung der Verwaltungsakte",
    admin_valid_desc: "Bestätigen Sie, dass die Informationen und Belege konform sind (formale Prüfung).",
    admin_valid_done: "Verwaltungsakte validiert. Sie können den Mittelabruf erstellen.",
    admin_valid_btn: "Verwaltungsakte validieren",
    admin_valid_cancel: "Validierung aufheben",
    admin_valid_need_docs: "Alle Belege müssen vor der Validierung akzeptiert sein.",
    gen_blocked: "Validieren Sie die Verwaltungsakte, um den Mittelabruf zu erstellen",
    section_title: "Verwaltung der Restzahlung",
    balance_due: "Offener Saldo",
    deadline: "Zahlungsfrist",
    received_title: "Erhaltene Zahlungen",
    received_empty: "Keine erhaltene Zahlung erfasst.",
    add_received: "Erhaltene Zahlung hinzufügen",
    col_date: "Eingangsdatum",
    col_emetteur: "Zahlungssender",
    col_emetteur_ph: "Name des Senders",
    col_montant: "Gezahlter Betrag",
    total_received: "Erhaltene Mittel gesamt",
    remaining: "Noch zu erhalten",
    mark_paid_btn: "Als bezahlt markieren",
    unlock_btn: "Entsperren",
    confirm_recu_btn: "Saldoeingang bestätigen",
    recu_confirmed: "Saldoeingang bestätigt",
    recu_cancel: "Bestätigung aufheben",
    save_confirm_title: "Erhaltene Zahlungen speichern?",
    save_confirm_desc: "Die eingegebenen Zahlungsfelder werden gesperrt. Sie können sie bei Bedarf später entsperren.",
    save_confirm_btn: "Speichern und sperren",
    recu_confirm_title: "Saldoeingang bestätigen?",
    recu_confirm_desc: "Der Saldo ist vollständig eingegangen. Diese Aktion markiert die Akte als bezahlt.",
    recu_confirm_btn: "Eingang bestätigen",
    cond_prestataire_facture: "Mindestens ein Dienstleister mit Rechnung gespeichert",
    validation_lock_banner: "Akte zur Validierung gesendet. Sie ist gesperrt, bis der Manager entscheidet.",
    send_validation_title: "Zur Validierung senden",
    send_validation_desc: "Akte zur Validierung der Dienstleisterzahlungen an den Manager senden.",
    send_validation_btn: "Zur Validierung senden",
    send_validation_confirm_title: "Akte zur Validierung senden?",
    send_validation_confirm_desc: "Die Akte wird an den Manager gesendet und bis zur Entscheidung vollständig gesperrt.",
    send_validation_confirm_btn: "Zur Validierung senden",
  },
  phase_d4b: {
    entreprise_nom: "Firmenname",
    resp_nom: "Nachname des gesetzlichen Vertreters",
    resp_prenom: "Vorname des gesetzlichen Vertreters",
    date_naissance: "Geburtsdatum",
    nationalite: "Staatsangehörigkeit",
    sanction_label: "Sanktionsprüfung durchgeführt",
    sanction_confirmed: "Sanktionsprüfung bestätigt",
  },

  gestiondoc: {
    title: "Dokumentenverwaltung",
    subtitle: "Dokumentvorlagen — laden Sie eine neue Version hoch, wenn sich eine Vorlage ändert.",
    add_template: "Vorlage hinzufügen",
    cat_gf: "Finanzielle Garantie",
    cat_rc_pro: "Berufshaftpflicht",
    cat_commun: "Allgemein",
    cat_sinistre: "Schäden",
    no_file: "Keine Datei",
    download: "Herunterladen",
    upload_new: "Neue Version",
    history: "Verlauf",
    systeme_tag: "Katalog",
    custom_tag: "Benutzerdefiniert",
    inactive: "Inaktiv",
    active: "Aktiv",
    delete_confirm: "Diese benutzerdefinierte Vorlage löschen?",
    empty: "Keine Vorlage.",
    hist_title: "Versionsverlauf",
    current_tag: "Aktuell",
    modal_upload_title: "Neue Version hochladen",
    modal_file: ".docx- oder .pdf-Datei",
    modal_notes: "Versionsnotiz (optional)",
    modal_upload_btn: "Hochladen",
    drop_hint: "Datei hierher ziehen oder klicken zum Durchsuchen",
    add_title: "Neue Vorlage",
    add_nom: "Vorlagenname",
    add_categorie: "Kategorie",
    add_desc: "Beschreibung",
    add_btn: "Vorlage erstellen",
  },
};

export default de;
